module.exports = __webpack_public_path__ + "static/media/main3_en.da0aa51d.png";